export default __webpack_public_path__ + "static/Bookmarks-Blue-edb3267d03b35e582e9f559c211d80ab.svg";